function Tags({ allText, selectedTag, handleClick, tags }) {
  return (
    <div className="image_tags">
      <div className={`image_tag ${selectedTag === "all" ? "active" : ""}`}>
        <p
          className={` ${selectedTag === "all" ? "active" : ""}`}
          onClick={() => handleClick("all")}
        >
          {allText}
        </p>
      </div>

      {tags?.map((tag, index) => (
        <div
          key={index}
          className={`image_tag ${tag._id === selectedTag ? "active" : ""}`}
          onClick={() => handleClick(tag._id)}
        >
          <p className={`${tag._id === selectedTag ? "active" : ""}`}>
            {tag.name}
          </p>
        </div>
      ))}
    </div>
  );
}

export default Tags;
